export const ALLMOVIES="ALLMOVIES";
export const MOVIEBYID="MOVIEBYID";
export const ALLMOVIESAPI='https://api.themoviedb.org/3/movie/popular?api_key=eba8b9a7199efdcb0ca1f96879b83c44';